var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ProfileOptInForm',_vm._b({attrs:{"is-sending":_vm.isSending,"success":_vm.success,"has-error":_vm.hasError,"error-message":_vm.errorMessage},on:{"subscribe":_vm.handleSubscribe,"hide-error":_vm.hideError}},'ProfileOptInForm',_vm.$props,false))
}
var staticRenderFns = []

export { render, staticRenderFns }